export const MapConfig = {
    Zoom: 10,
    Saudi: {
        Lat: 24.7136,
        Lng: 46.6753
    }
}